import angular from 'angular';
import gridHeight from '../../core/shared-service/grid-utils';

(function() {
    'use strict';

    var orderDetailInvoices = {
        templateUrl: require('./order-detail-invoices.html'),
        bindings: {
            order: '<', // Commande
            invoices: '<' // Factures associés à la commande
        },
        controller: OrderDetailInvoicesController
    };

    OrderDetailInvoicesController.$inject = ['UtilSvc', 'uiGridConstants'];

    function OrderDetailInvoicesController(UtilSvc, uiGridConstants) {
        var vm = this;
        vm.getGridHeight = getGridHeight;

        vm.gridOptions = {
            columnDefs: [
                {
                    name: 'number',
                    displayName: 'kiss_order.invoice_num',
                    headerCellFilter: 'translate',
                    cellTemplate:
                        '<div class="ui-grid-cell-contents"><a href="" ng-href="{{row.entity.getPdfLink()}}" target="_blank">{{COL_FIELD CUSTOM_FILTERS}}</a></div>'
                },
                {
                    name: 'date',
                    displayName: 'kiss_order.invoice_date',
                    headerCellFilter: 'translate',
                    sort: { direction: 'desc', priority: 0 }
                },
                {
                    name: 'type',
                    displayName: 'commons.type',
                    headerCellFilter: 'translate',
                    cellTemplate:
                        '<div class="ui-grid-cell-contents">{{\'kiss_order.type.\' + COL_FIELD CUSTOM_FILTERS | lowercase | translate}}</div>'
                },
                {
                    name: 'exclusiveTaxAmount',
                    displayName: 'kiss_order.exclusive_tax_amount_line',
                    headerCellFilter: 'translate',
                    cellFilter: 'number:2',
                    cellClass: 'text-right'
                },
                {
                    name: 'taxAmount',
                    displayName: 'kiss_order.tax_amount',
                    headerCellFilter: 'translate',
                    cellFilter: 'number:2',
                    cellClass: 'text-right'
                },
                {
                    name: 'netPayable',
                    displayName: 'kiss_order.net_payable',
                    headerCellFilter: 'translate',
                    cellFilter: 'number:2',
                    cellClass: 'text-right'
                },
                { name: 'currency', displayName: 'kiss_order.currency', headerCellFilter: 'translate' },
                {
                    name: 'orderCompliance',
                    displayName: 'kiss_order.order_compliance',
                    headerCellFilter: 'translate',
                    cellTemplate:
                        '<div class="ui-grid-cell-contents">{{\'kiss_order.compliance.\' + COL_FIELD CUSTOM_FILTERS | lowercase | translate}}</div>'
                }
            ],
            exporterOlderExcelCompatibility: true,
            enableSorting: true,
            onRegisterApi: onRegisterApi,
            enableGridMenu: false,
            enableColumnMenus: false,
            enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER
        };

        vm.$onChanges = function(changesObj) {
            if (changesObj.invoices && changesObj.invoices.currentValue) {
                vm.gridOptions.data = changesObj.invoices.currentValue;
                vm.gridOptions.totalItems = changesObj.invoices.currentValue.length;
            }
        };

        // Grille
        function onRegisterApi(gridApi) {
            vm.gridApi = gridApi;
        }

        function getGridHeight() {
            return gridHeight(vm.gridApi);
        }
    }

    angular.module('app.kissorder').component('orderDetailInvoices', orderDetailInvoices);
})();
